import { useParams, usePathname } from 'next/navigation';
import { getSeoUrl, normalizeCommerceLink } from 'utils/links';
import { B2C_LOGIN_URL } from 'constants/links';

export const useLoginUrl = () => {
  const params = useParams();
  const esiteUrl = getSeoUrl(params);
  const pathname = usePathname();
  const isHomePage = esiteUrl === pathname;

  const loginUrl = normalizeCommerceLink(
    getSeoUrl(params, B2C_LOGIN_URL, {
      pageRedirectUrl: pathname,
      loginFromHomePage: isHomePage
    })
  );

  return loginUrl;
};
